<div [ngClass]="floatLabel ? 'p-float-label' : ''">
  <input
    #pass
    id="float-input"
    type="password"
    autocomplete="off"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    class="p-inputtext p-widget"
    [pTooltip]="tooltipText"
    [ngClass]="!valid ? 'form-field-invalid' : ''"
    tooltipEvent="focus"
    (input)="passwordChanged(pass.value); propagateChange(pass.value)"
    pInputText
  />
  <div
    [style.background-color]="safetyBarColor"
    [style.width]="safetyBarWidth"
    style="height: 4px; transition: 0.5s"
  ></div>
  <label *ngIf="floatLabel" for="float-input">{{ floatLabel }}</label>
</div>
